import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Routes, Route } from 'react-router-dom';
// import Peacockvalley from './components/PeacockValley';
import About from './components/AboutUs';
import Media from './components/Media';
import Employment from './components/Employment';
import CP from './components/Cp';
import Facilities from './components/Facilities';
import Layout from './Layout';
import Contact from './components/ContactUs';
import Team from './components/OurTeam';
import LeadershipTeam from './components/OurTeam';
import Testimonials from './components/Gallery2';
import CustomSlider from './components/Gallery';
import Projects from './components/CompletedProjects';
import UpComingProjects from './components/UpcomingProjects';
import WhySamriddhi from './components/WhySamriddhi';
import DemoForm from './components/DemoForm';
import EnquiryForm from './components/EnquiryForm';
// import NewNavbar from './components/NewNavbar';
// import NewHeroSection from './components/NewHeroSection';
import GoogleReviews from './components/GoogleReviews';
import Whatsapp from './components/Whatsapp';
import Faq from './components/Faq';
import Lonavalley from './components/Lonavalley';
import InvestmentLanding from './components/InvestmentLanding';
import PositiveLeads from './components/PositiveLeads';
import SiteVisitForm from './components/SiteVisitForm';
import Blog from './components/Blog';
import Waterscape from './components/Waterscape';
import RivieraGreens from './components/RivieraGreens';
import MemoryWall from './components/MemoryWall';

import LifeAtSG from './components/LifeAtSG';
import OpenRoles from './components/OpenRoles';

import JobDetail from './components/JobDetail';

import CPResourcePage from './components/CPResourcePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<App />} />
        <Route path="home" element={<App />} />
        {/* <Route path="peacockValley" element={<Peacockvalley />} /> */}
        <Route path="about" element={<About />} />
        <Route path="media" element={<Media />} />
        <Route path="employment" element={<Employment />} />
        <Route path="cp" element={<CP />} />
        <Route path="facilities" element={<Facilities />} />
        <Route path="contact" element={<Contact />} />
        {/* <Route path="peacockValleyProject" element={<Peacockvalley />} /> */}
        <Route path="ourteam" element={<LeadershipTeam />} />
        <Route path="testimonials" element={<Testimonials />} />
        <Route path="gallery" element={<CustomSlider />} />
        <Route path="completedProjects" element={<Projects />} />
        <Route path="upComingProjects" element={<UpComingProjects />} />
        <Route path="whyus" element={<WhySamriddhi />} />
        <Route path='demoForm' element={<DemoForm />}></Route>
        <Route path='enquiryForm' element={<EnquiryForm />}></Route>
        <Route path='googlereviews' element={<GoogleReviews />}></Route>
        <Route path='faq' element={<Faq />}></Route>
        <Route path='lonavalley' element={<Lonavalley />}></Route>
        <Route path='investmentpuneplots' element={<InvestmentLanding />}></Route>
        <Route path='positiveleads' element={<PositiveLeads />}></Route>
        <Route path='siteVisit' element={<SiteVisitForm />}></Route>
        <Route path='blogs' element={<Blog />}></Route>
        <Route path='waterscape-premium-water-touch-plots' element={<Waterscape />}></Route>
        <Route path='riviera-Greens-dam-view-plots' element={<RivieraGreens />}></Route>
        <Route path='memory-wall' element={<MemoryWall />}></Route>
        <Route path='life-at-samriddhi-group' element={<LifeAtSG />}></Route>
        <Route path='all-jobs' element={<OpenRoles />}></Route>

        <Route path="/careers/job/:id" element={<JobDetail />} />

        <Route path="/cp-kit" element={<CPResourcePage />} />





        {/* <Route path='newNavbar' element={<NewNavbar />}></Route>
        <Route path='newHeroSection' element={<NewHeroSection />}></Route> */}
      </Route>
    </Routes>
  </HashRouter>
);

reportWebVitals();
